import React, { FC } from 'react';

interface HeroSectionProps {
    title: string;
    subtitle?: string;
    style?: React.CSSProperties;
    className?: string;
    'data-testid'?: string;
}

export const HeroSection: FC<HeroSectionProps> = ({
    title,
    subtitle,
    style,
    className = '',
    'data-testid': testId,
}) => {
    return (
        <div className={`flex flex-col gap-1 ${className}`} style={style} data-testid={testId}>
            <h1 className="m-0 text-xl font-bold leading-8 text-blackTitle">{title}</h1>
            {subtitle && <p className="m-0 text-base font-normal leading-[22px] text-backgroundGreyAlt7">{subtitle}</p>}
        </div>
    );
};

export default HeroSection;
